import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    padding: 5.2em 0;
    background-color: #000;
    color: #fff;

    .subtitle {
        font-size: 1em;
        font-weight: 600;
        margin-bottom: 2.4em;
        text-align: center;
        padding: 0 3em;
    }

    .title {
        font-size: 1.8em;
        font-weight: 600;
        margin-bottom: 2em;
        text-align: center;
    }

    .boxs-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        width: 100%;

        @keyframes visible {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }

        .box {
            width: 48%;
            margin: .5em;
            max-width: 30em;
            height: 30em;
            background-color: #fff;
            position: relative;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            opacity: 1;

            &:hover .description{
                animation: visible .25s ease-in-out;
            }

            .image-dektop {
                max-width: 12em;
            }

            .image-mobile {
                display: none;
            }

            .description {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: #fff;
                color: #000;
                text-align: center;
                padding: 3em;
                font-size: .9em;
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 0;

                &:hover {
                    opacity: 1;
                }
            }
        }
    }

    @media all and (max-width: ${vars.tabletS}) {
        .subtitle {
            font-size: 1.2em;
            padding: 0 2em;
        }

        .title {
            display: none;
        }

        .boxs-wrapper {
            .box {
                width: 98%;
                margin: .5em;
                max-width: 30em;
                height: 100%;
                position: relative;
                background-color: #000;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                opacity: 1;

                .image-desktop {
                    display: none;
                }

                .image-mobile {
                    display: flex;
                    max-width: 12em;
                }

                .description {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    background-color: #000;
                    color: #fff;
                    text-align: center;
                    padding: 3em 1em;
                    font-size: 1.1em;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    opacity: 1;
                }
            }
        }
    }
`;